export interface ContractUserDetails {
  id: number;
  username: string;
  name: string;
  email: string;
  phoneNumber: string;
  companyName: string;
  roleName: string;
  copyToRamapp: boolean;
}

export interface ContractUserAccess {
  contractId: number;
  userId: number;
  accessLevel: ContractAccessLevel;
}

export enum ContractAccessLevel {
  NoAccess = 0,
  RegularUser = 1,        // Käyttäjä - is_active column
  ContractorForeman = 2,  // Urakoitsijan työnjohtaja - is_contractor_foreman
  ClientForeman = 3,      // Tilaajan työnjohtaja - is_foreman
  BillingUser = 4,        // Laskuttaja - is_officeuser
  ContractorBilling = 5   // Urakoitsijan laskuttaja - is_contractor_officeuser
}

export interface ContractUserRow extends ContractUserDetails {
  contractAccess: Record<number, ContractAccessLevel>;
}

export interface ContractUserSaveRequest {
  users: ContractUserUpdateRequest[];
  addressSystemId: number;
  contractStatusId: number;
}

export interface ContractUserUpdateRequest {
  id: number;
  name: string;
  email: string;
  phoneNumber: string;
  copyToRamapp: boolean;
  contractAccess: Record<number, ContractAccessLevel>;
}

export interface ContractUserResponse {
  users: ContractUserRow[];
  contracts: ContractListItem[];
}

export interface ContractListItem {
  id: number;
  name: string;
}

export interface ContractStatus {
  id: number;
  name: string;
  defaultValue?: number;
  addressSystemId: number;
  orderInGroup?: number;
}
